/**
 * Inits the datepicker with the config read from the container data-attributes.
 * @param {Node} datepicker
 */
function initDatepicker(datepicker) {
  const config = {};
  const $datepicker = $(datepicker);
  const yearMin = $datepicker.attr('yearMin');
  const yearMax = $datepicker.attr('yearMax');
  const changeYear = $datepicker.attr('changeyear');
  const changeMonth = $datepicker.attr('changemonth');

  if (yearMin) {
    config.minDate = new Date(yearMin, 0);
  }

  if (yearMax) {
    config.maxDate = new Date(yearMax, 11, 31);
  }

  if (changeYear.length) {
    config.changeYear = true;
  }

  if (changeMonth.length) {
    config.changeMonth = true;
  }

  if (yearMin && yearMax) {
    config.yearRange = `${yearMin}:${yearMax}`;
  }

  $datepicker.datepicker(config);
  // Trigger focusout to clear validation messages
  $datepicker.on('change', event => $(event.currentTarget).trigger('focusout'));
}

/**
 * Loops through the dom and inits datepickers
 */
export const initDatepickers = () => {
  $.each($('.js-datepicker'), (index, datepicker) => initDatepicker(datepicker));
};
